// in src/posts.js
import React, { useEffect, useState } from 'react';
import { Filter, ImageField, DeleteButton, DateField, BooleanField, DateTimeInput, RichTextField, SimpleShowLayout, Show, ShowButton, SimpleList, Responsive, BooleanInput, List, Edit, Create, Datagrid, ReferenceField, TextField, EditButton, DisabledInput, LongTextInput, ReferenceInput, required, SelectInput, SimpleForm, TextInput,useDataProvider } from 'react-admin';
import { DateTimePicker } from '@mui/x-date-pickers/DateTimePicker';
import TextFieldFrom from '@mui/material/TextField';
import FormControlLabel from '@mui/material/FormControlLabel';
import { RichTextInput } from 'ra-input-rich-text';
import { useNotify, useRedirect } from 'react-admin';

import InputUploadInput from '../mui/field/UploadInput';
import { AdapterDayjs } from '@mui/x-date-pickers/AdapterDayjs';
import { getAuthApp } from '../services/security/authApp';
import Constants from '../shared/constants';
import Popup from 'reactjs-popup';
import Validators from './renderFields/validatorsFields';


//import DateTimePicker from 'material-ui/DateTimePicker';

//Utils
import {
    Box, Button, Dialog, Grid, DialogActions, DialogContent, DialogContentText, DialogTitle, FormControl, InputLabel,
    Select, Switch as MuiSwitch
} from '@mui/material';
import { LocalizationProvider } from '@mui/x-date-pickers';
import Autocomplete from '@mui/material/Autocomplete';
import Alert from '@mui/material/Alert';
import Switch from '@mui/material/Switch';
import CustomRichTextInput from '../mui/field/CustomRichTextInput';


//material-ui table
import Table from '@mui/material/Table';
import TableBody from '@mui/material/TableBody';
import TableCell from '@mui/material/TableCell';
import TableContainer from '@mui/material/TableContainer';
import TableHead from '@mui/material/TableHead';
import TableRow from '@mui/material/TableRow';
import Paper from '@mui/material/Paper';

//temas para responsivo
import { useTheme, useMediaQuery } from '@mui/material';

const cardActionStyle = {
    zIndex: 2,
    display: 'inline-block',
    float: 'right',
};

const CustomErrorMessage = (error) => {
    return '¡Ocurrió un error con el formulario! Por favor verifique los campos.';
};
const validateDates = (values) => {
    const errors = {};
    const { fecha_hora_inicio, fecha_hora_final, descripcion_Contador, nuevo_formato_contador, texto_boton, url_form } = values;

    if (fecha_hora_inicio && fecha_hora_final && new Date(fecha_hora_final) < new Date(fecha_hora_inicio)) {
        errors.fecha_hora_final = 'La fecha final no puede ser menor a la fecha de inicio.';
    }

    if (descripcion_Contador && descripcion_Contador.length > 100) {
        errors.descripcion_Contador = 'El contador no puede tener más de 100 caracteres.';
    }

    if (nuevo_formato_contador && nuevo_formato_contador.length > 100) {
        errors.nuevo_formato_contador = 'El formato del contador no puede tener más de 100 caracteres.';
    }

    if (texto_boton && texto_boton.length > 50) {
        errors.texto_boton = 'El texto del botón no puede tener más de 50 caracteres.';
    }

    if (url_form && url_form.length > 50) {
        errors.url_form = 'La URL no puede tener más de 50 caracteres.';
    }

    if (!values.imagen_de_fondo) {
        errors.imagen_de_fondo = 'La imagen de fondo es obligatoria.';
    }

    if (!values.nueva_imagencontador) {
        errors.nueva_imagencontador = 'La imagen del contador es obligatoria.';
    }

    return errors;
};

const estados = [
    "ACTIVO",
    "INACTIVO"
];
const NewFilterConteoRegresivo = (props) => (
    <Filter {...props}>
        <TextInput label="Buscar" source="texto_boton" alwaysOn />
    </Filter>
);
export const NewListConteoRegresivo = (props) => {
    const theme = useTheme();
    const isSmall = useMediaQuery(theme.breakpoints.down('sm'));

    return (
        <List {...props} title="Listar Conteo Regresivo" filters={<NewFilterConteoRegresivo />}>
            {isSmall ? (
                <SimpleList
                    primaryText={record => record.descripcion_Contador}
                    secondaryText={record => new Date(record.fecha_hora_inicio).toLocaleDateString()}
                    tertiaryText={record => record.texto_boton}
                />
            ) : (
                <Datagrid>
                    <TextField source="id" />
                    <TextField source="descripcion_Contador" label="Contador Regresivo" />
                    <TextField source="texto_boton" label="Texto botón" />
                    <TextField source="url_form" label="URL" />
                    <DateField source="fecha_hora_inicio" label="Fecha y hora de inicio" />
                    <DateField source="fecha_hora_final" label="Fecha y hora fin" />
                    <BooleanField source="activo" label="Estado" />
                    <EditButton />
                    <ShowButton />
                    <DeleteButton 
                        mutationMode="pessimistic"
                        confirmTitle="¿Está seguro de eliminar el registro?"
                        confirmContent=" "
                        successMessage="Registro eliminado exitosamente." // Mensaje de éxito después de la eliminación

                    />
                    </Datagrid>
            )}
        </List>
    );
};


const NewNameConteoRegresivo = ({ record }) => {
    return <span>Conteo  {record ? `"${record.id}"` : ''}</span>;
};

export const NewEditConteoRegresivo = (props) => (
    <Edit title={<NewNameConteoRegresivo />} {...props}>
        <SimpleForm validate={validateDates}>
            <RichTextInput source="descripcion_Contador" label="Contador Regresivo" validate={required()} />
            <div style={{ marginBottom: '1em' }}>
                <InputUploadInput source="imagen_de_fondo" label="Imagen de fondo" validate={required()} />
            </div>

            <div style={{ display: 'flex', gap: '1em', marginBottom: '1em' }}>
                <TextInput source="texto_boton" label="Texto botón" validate={required()} />
                <TextInput source="url_form" label="URL" />
                <BooleanInput label="Estado" source="activo" defaultValue={true} />
            </div>

            <div style={{ display: 'flex', gap: '1em', marginBottom: '1em' }}>
                <DateTimeInput source="fecha_hora_inicio" label="Fecha Inicio" />
                <DateTimeInput source="fecha_hora_final" label="Fecha Fin" />
            </div>

            <RichTextInput source="nuevo_formato_contador" label="Formato para el conteo regresivo" validate={required()} />
            <InputUploadInput source="nueva_imagencontador" label="Imagen del contador" validate={required()} />
        </SimpleForm>
    </Edit>
);

export const NewCreateConteoRegresivo = (props) => {
    const notify = useNotify();
    const redirect = useRedirect();
    const dataProvider = useDataProvider(); 
    const [openConfirmModal, setOpenConfirmModal] = useState(false);
    const [formData, setFormData] = useState(null);
    const [loading, setLoading] = useState(false); // Estado para controlar la carga

    const handleOpenModal = () => setOpenConfirmModal(true);

    const handleCloseModal = () => {
        // Solo podemos cerrar el modal si no está en proceso de guardado
        if (!loading) {
            setOpenConfirmModal(false);
        }
    };

    const handleConfirmSave = async () => {
        setLoading(true); 
        try {
            await dataProvider.create('/conteoregresivo', { data: formData }); 
            notify('Registro Creado con éxito', { type: 'success' });
            redirect('/conteoregresivo'); 
            setOpenConfirmModal(false); 
        } catch (error) {
            console.error(error);
            notify('Se presentaron errores al almacenar la información del conteo regresivo', { type: 'error' });
        } finally {
            setLoading(false); 
        }
    };

    return (
        <>
            <Create {...props} title="Crear Conteo Regresivo">
                <SimpleForm
                    onSubmit={(data) => {
                        setFormData(data); 
                        handleOpenModal(); 
                    }}
                    
                >
                    <RichTextInput
                        source="descripcion_Contador"
                        label="Contador Regresivo"
                        isRequired={true}
                        validate={[Validators.required,Validators.maxLengthContadordes,Validators.noImagesInText]} // Aquí aplicamos la validación para máximo 100 caracteres
                        />

                    <div style={{ marginBottom: '1em' }}>
                        <InputUploadInput
                            source="imagen_de_fondo"
                            label="Imagen de fondo"
                            validate={[Validators.required]}
                        />
                    </div>

                    <div style={{ display: 'flex', gap: '1em', marginBottom: '1em' }}>
                        <TextInput source="texto_boton" label="Texto botón" validate={[Validators.requiredTextBt,Validators.maxLengthContadorbton]} />
                        <TextInput source="url_form" label="URL" required={false} validate={[Validators.requiredurl,Validators.maxLengthContadorurl]} />
                        <BooleanInput label="Estado" source="activo" defaultValue={true} />
                    </div>

                    <div style={{ display: 'flex', gap: '1em', marginBottom: '1em' }}>
                        <DateTimeInput source="fecha_hora_inicio" label="Fecha y hora de inicio" validate={[Validators.requiredFI]}/>
                        <DateTimeInput source="fecha_hora_final" label="Fecha y hora fin" validate={[Validators.requiredFIN,Validators.fechaFinalMayorQueInicio]}/>
                    </div>

                    <RichTextInput
                        source="nuevo_formato_contador"
                        label="Formato para el conteo regresivo"
                        isRequired={true}
                        validate={[Validators.requiredForma,Validators.maxLengthContadorforma,Validators.noImagesInText]}
                    />
                    <InputUploadInput
                        source="nueva_imagencontador"
                        label="Imagen del contador"
                        validate={[Validators.required]}
                    />
                </SimpleForm>
            </Create>

            <Dialog
                open={openConfirmModal}
                onClose={handleCloseModal}
                aria-labelledby="alert-dialog-title"
                aria-describedby="alert-dialog-description"
                disableBackdropClick={loading}  
                disableEscapeKeyDown={loading} 
            >
                <DialogTitle id="alert-dialog-title">
                    {"¿Está seguro de guardar la información del contador regresivo?"}
                </DialogTitle>
                <DialogContent>
                    <DialogContentText id="alert-dialog-description">
                    </DialogContentText>
                </DialogContent>
                <DialogActions>
                    <Button onClick={handleCloseModal} color="primary" disabled={loading}>
                        No
                    </Button>
                    <Button
                        onClick={handleConfirmSave}
                        color="primary"
                        autoFocus
                        disabled={loading} 
                    >
                        {loading ? 'Guardando...' : 'Sí'} 
                    </Button>
                </DialogActions>
            </Dialog>
        </>
    );
};
export const NewShowConteoRegresivo = (props) => (
    <Show title={<NewNameConteoRegresivo />} {...props}>
        <SimpleShowLayout>
            <RichTextField source="descripcion_Contador" label="Contador Regresivo" />
            <ImageField source="imagen_de_fondo" label="Imagen de fondo" />
            <TextField source="texto_boton" label="Texto botón" />
            <TextField source="url_form" label="URL" />
            <BooleanField label="Estado" source="activo" />
            <DateField source="fecha_hora_inicio" label="Fecha y hora de inicio" />
            <DateField source="fecha_hora_final" label="Fecha y hora fin" />
            <RichTextField source="nuevo_formato_contador" label="Formato para el conteo regresivo" />
            <ImageField source="nueva_imagencontador" label="Imagen del contador" />
        </SimpleShowLayout>
    </Show>
);